import { responseError } from "@/lib/response-error";
import type { ArenaSample } from "./types";

const requiredKeys: Array<keyof ArenaSample> = [
  "id", "promptId", "language", "category", "text",
  "provider", "model", "voiceId", "voiceName",
  "requestedSpeed", "audioPath", "durationMs", "mimeType", "generatedAt",
];

const MANIFEST_URL = (window as { __TTS_ARENA_MANIFEST_URL__?: string }).__TTS_ARENA_MANIFEST_URL__
  ?? "/api/internal/tts-arena/manifest";

export async function loadManifest(): Promise<ArenaSample[]> {
  const response = await fetch(MANIFEST_URL, { cache: "no-store" });
  if (!response.ok) {
    throw await responseError(response, "Could not load TTS evaluation samples");
  }
  const json = (await response.json()) as unknown;
  if (!Array.isArray(json)) throw new Error("manifest.json must be an array");
  return json.map((sample, index) => validateSample(sample, index));
}

function validateSample(value: unknown, index: number): ArenaSample {
  if (!value || typeof value !== "object") throw new Error(`Manifest sample ${index} must be an object`);
  const sample = value as ArenaSample;
  for (const key of requiredKeys) {
    if (sample[key] === undefined || sample[key] === null || sample[key] === "") {
      throw new Error(`Manifest sample ${index} is missing ${key}`);
    }
  }
  if (sample.audioPath.includes("..")) {
    throw new Error(`Manifest sample ${sample.id} has an invalid audioPath`);
  }
  return sample;
}
